import { Tooltip } from '~/components/component-library'
import { absoluteTimeDiff } from '~/components/component-library/Timestamp/absoluteTimeDiff'
import { relativeTimeDiff } from '~/components/component-library/Timestamp/relativeTimeDiff'
import { type TimestampProps } from '~/components/component-library/Timestamp/types'
import {
  formatWithLocalTimezone,
  ONE_WEEK_MS,
  getTimeDiffMs,
} from '~/utils/time'

export { type TimestampProps } from '~/components/component-library/Timestamp/types'

export const Timestamp = ({
  timestamp,
  type,
  abbreviate = false,
  showTooltip,
  tz = 'local',
}: TimestampProps) => {
  if (!timestamp) {
    return <span className="whitespace-nowrap text-secondary">Unknown</span>
  }

  const getDisplayValue = () => {
    if (type === 'absolute')
      return absoluteTimeDiff(timestamp, { abbreviate, tz })

    const diffMs = Math.abs(getTimeDiffMs(timestamp))
    if (diffMs >= ONE_WEEK_MS)
      return absoluteTimeDiff(timestamp, { abbreviate, tz })

    return relativeTimeDiff(timestamp, { suffix: 'ago', abbreviate })
  }

  const shouldShowTooltip = showTooltip ?? type === 'relative'
  const display = <span className="whitespace-nowrap">{getDisplayValue()}</span>

  if (!shouldShowTooltip) return display

  return (
    <Tooltip
      className="relative inline-flex"
      content={formatWithLocalTimezone(new Date(timestamp), {
        format: 'DD MMM YYYY [at] h:mm A',
        tz,
      })}
      delay={400}
    >
      {display}
    </Tooltip>
  )
}
